import { Switch, useRouteMatch, Route, Redirect } from "react-router-dom";
import { Flex } from "@jsq/ds/core";
import { Column, ColumnContainer } from "@jsq/ds/layouts";
import { useFeatureFlag } from "@jsq/flags-react";
import { useAppContext } from "~/contexts/appContext";
import { isFundAccountingController } from "~/utils/userRoles";
import { ArenaDetail } from "./ArenaDetail/ArenaDetail";
import { Arenas } from "./Arenas/Arenas";
import { CashProcessing } from "./CashProcessing/CashProcessing";
import { FundDetailsPage } from "./CashProcessing/FundDetailsPage";
import { Entities } from "./Entities/Entities";
import * as styles from "./styles_vanilla.css";
import { TransactionLookup } from "./TransactionLookup";

type Props = {
  userId?: number;
};
export const FundAccounting = ({ userId }: Props) => {
  const { path } = useRouteMatch();
  const { user } = useAppContext();
  const showTransactionLookupFF = useFeatureFlag("showTransactionLookup", false);
  const canAccessTransactionLookup =
    isFundAccountingController(user?.roles) && showTransactionLookupFF;

  return (
    <Flex className={styles.wrapperContainer}>
      <div className={styles.layoutContainer}>
        <Flex flexDirection="column" className={styles.contentWrapper}>
          <div className={styles.contentArea}>
            <ColumnContainer className={styles.fundAccountingColumnContainer}>
              <Column size="xl">
                <Switch>
                  <Route exact path={path}>
                    <Arenas />
                  </Route>
                  <Route path={`${path}/arena/:id`}>
                    <ArenaDetail>
                      <Entities userId={userId} />
                    </ArenaDetail>
                  </Route>
                  <Route exact path={`${path}/cash-processing`}>
                    <CashProcessing />
                  </Route>
                  <Route path={`${path}/cash-processing/fund/:id`}>
                    <FundDetailsPage />
                  </Route>
                  <Route path={`${path}/transaction-lookup`}>
                    {canAccessTransactionLookup ? (
                      <TransactionLookup />
                    ) : (
                      <Redirect to={path} />
                    )}
                  </Route>
                </Switch>
              </Column>
            </ColumnContainer>
          </div>
        </Flex>
      </div>
    </Flex>
  );
};
